import { BillingNotifications } from '@features/Admin/Billing/ui/BillingNotifications';
import {
  Button,
  Chip,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { IconMenu2, IconSparkles } from '@tabler/icons-react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@shared/store';
import { actions } from '@shared/store/ducks';
import Profile from '@shared/layouts/FullLayout/vertical/header/Profile';
import { useDesignVariant } from './DesignVariantProvider';
import { useDesignWorkspace } from './DesignWorkspaceProvider';
import { DesignChooser } from './DesignChooser';

export const DesignHeader = () => {
  const { variant } = useDesignVariant();
  const workspace = useDesignWorkspace();
  const { pathname } = useLocation();
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('md'));
  const dispatch = useAppDispatch();
  const company = useAppSelector((state) => state.auth.authenticatedUserCompany);
  const title =
    (workspace.module === 'Agents' && variant === 'v5' ? 'Assistants' : workspace.module) ||
    (pathname === '/workspace/campaign/new'
      ? 'Create a campaign'
      : pathname.startsWith('/workspace/campaign/')
        ? pathname.endsWith('/new')
          ? 'Create an assistant'
          : 'Agent studio'
        : pathname === '/billing'
          ? 'Billing'
          : pathname.includes('/assistants')
            ? 'Job library'
            : pathname.includes('/campaign/')
              ? 'Campaign setup'
              : 'Campaigns');
  // V2's desktop layout starts directly with the page heading.
  if (['v2', 'v3'].includes(variant) && desktop) return null;
  return (
    <Stack
      component="header"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        minHeight: variant === 'v4' ? 58 : 64,
        px: { xs: 2, md: variant === 'v5' ? 4 : 3.5 },
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        flexShrink: 0,
      }}>
      <Stack direction="row" gap={1.5} alignItems="center" sx={{ minWidth: 0 }}>
        {!desktop && (
          <IconButton
            aria-label="Open navigation"
            onClick={() => dispatch(actions.customizer.setMobileSidebar(true))}>
            <IconMenu2 size={20} />
          </IconButton>
        )}
        {variant !== 'v4' && (
          <>
            <Typography variant="caption" color="text.secondary" noWrap>
              {variant === 'v1' ? company?.title : 'Workspace'}
            </Typography>
            <Typography color="text.disabled">/</Typography>
          </>
        )}
        <Typography variant="body2" fontWeight={550} noWrap>
          {title}
        </Typography>
      </Stack>
      <Stack direction="row" gap={1} alignItems="center">
        <BillingNotifications />
        {variant === 'v5' ? (
          <Button
            size="small"
            startIcon={<IconSparkles size={15} />}
            onClick={() => workspace.open('Ask Callevate')}>
            Ask Callevate
          </Button>
        ) : variant === 'v4' ? (
          <>
            <Typography variant="caption" color="text.secondary">
              Callevate
            </Typography>
            <Chip label="V4" size="small" variant="outlined" />
          </>
        ) : (
          <DesignChooser compact />
        )}
        {!desktop && (
          <>
            {['v4', 'v5'].includes(variant) && <DesignChooser compact />}
            <Profile drawer />
          </>
        )}
      </Stack>
    </Stack>
  );
};
